import React, { Component } from 'react';
import Form from '../../../lib/ui/form';
import { Row, Button, notification, Spin, Divider } from 'antd';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { showErrorInNotification, showSuccessInNotification } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';

// min_length, 
// max_length, 
// requires_lower, 
// requires_upper, 
// requires_digit, 
// requires_special,
// history_unique,
// expiry_interval,


const password_basic = [
  {
    name: "Min Length",
    index: 'min_length',
    type: 'number',
    required: true
  },
  {
    name: "Max Length",
    index: 'max_length',
    type: 'number',
    required: true
  },

  {
    name: "Require Lower Character",
    index: 'requires_lower',
    type: 'bool',
  },
  {
    name: "Require Upper Character",
    index: 'requires_upper',
    type: 'bool',
  },
  {
    name: "Require Digit",
    index: 'requires_digit',
    type: 'bool',
  },
  {
    name: "Require Special Character",
    index: 'requires_special',
    type: 'bool',
  },
]
const password_expiry = [
  {
    name: "Inactivity Interval (in minute)",
    help_text: "Auto logout user after X minute from device.",
    index: 'inactivity_interval',
    type: 'number',
  },
  {
    name: "Last X Unique Password (0 for reuse)",
    help_text: "Cannot set last X old password.",
    index: 'history_unique',
    type: 'number',
  },
  {
    name: "Password Expires After X Days (0 for never expire)",
    help_text: "User have to change password after X days to continue.",
    index: 'expiry_interval',
    type: 'number',
  },
  {
    name:"Allow Multiple Sessions",
    index:'allow_multiple_session',
    type:'bool'
  }
  // {
  //   name: "Access Token Expires After X Seconds ",
  //   // help_text:"User have to change password after X days to continue.",
  //   index: 'access_token_life',
  //   type: 'number',
  // },
  // {
  //   name: "Refresh Token Expires After X Seconds",
  //   // help_text:"User have to change password after X days to continue.",
  //   index: 'refresh_token_life',
  //   type: 'number',
  // }
]

class PasswordPolicySetting extends Component {
  constructor(props) {
    super(props)

    this.state = {
      form_data: {}
    }

    this.get_setting = RESTExecutor.detail().config({
      label: 'password_setting'
    }).callbacks((success) => {
      this.setState({ form_data: (success.result) || {} });
    }, (error) => {
      console.log("error", error);
      showErrorInNotification(error)
    }).connect(props.domains.appSetting);

    this.set_setting = RESTExecutor.post().config({
      label: 'password_setting'
    }).callbacks((success) => {
      console.log("success", success);
      showSuccessInNotification(success,"Settings Updated")
    }, (error) => {
      console.log("error", error);
      showErrorInNotification(error);
    }).connect(props.domains.appSetting);

    this.get_setting.execute();
  }

  updateSetting = () => {
    let data = JSON.parse(JSON.stringify(this.state.form_data));
    let sending_data = data;
    // Object.keys(data).map((key) => {
    //   let value = data[key];
    //   sending_data[key] = {
    //     "user_hierarchy": value
    //   }
    // });
    console.log("sending data", sending_data)

    this.set_setting.execute(sending_data)


  }

  render() {
    let set_setting_resp = this.set_setting.response();
    let get_setting_resp = this.get_setting.response();
    if (get_setting_resp.fetching) {
      return <center><Spin /></center>
    }
    return (
      <div>
        <ErrorWrapper
          error={get_setting_resp}
          onReload={() => {
            this.get_setting.execute();
          }}
        >
          <div className='heading-1'>Password Policy</div>
          <Form
            hideTitle
            forCreate={true}
            initialData={this.state.form_data || {}}
            submitted={this.state.submitted}
            onChange={(data) => {
              this.setState({ form_data: data })
            }}
            fields={password_basic}
            submitting={{}}
            errorMessage={set_setting_resp.error_message}
            validationErrors={set_setting_resp.validation_errors}
          />
          <Divider />
          <div className='heading-1' style={{
          }}>Expiry Setting</div>
          <Form
            hideTitle
            forCreate={true}
            initialData={this.state.form_data || {}}
            submitted={this.state.submitted}
            onChange={(data) => {
              this.setState({ form_data: data })
            }}
            fields={password_expiry}
            submitting={{}}
            errorMessage={set_setting_resp.error_message}
            validationErrors={set_setting_resp.validation_errors}
          />
          <br></br>
          <Row type='flex' justify='end'>
            <Button type='primary'
              disabled={set_setting_resp.fetching}
              loading={set_setting_resp.fetching}
              onClick={() => {
                this.setState({ submitted: true });
                this.updateSetting()
              }}
            >Submit</Button>
          </Row>
        </ErrorWrapper>

      </div>
    );
  }
}

export default withDomains(PasswordPolicySetting, "appSetting");
